import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import F1 from "../Images/footerlogo.svg";
import F2 from "../Images/instafooter.svg";
import F3 from "../Images/footerfacebook.svg";
import F4 from "../Images/footertwit.svg";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <>
      {/* footer */}
      <div className="container p-0">
        <div className="mt-md-5 mt-3">
          <div className="row  mx-md-0 mx-3 mt-md-5 mt-sm-3 py-4">
            <div className="col-md-1 "></div>
            <div className="col-md-3 col p-0 ">
              <a to="/">
                <img
                  className="mb-3"
                  style={{ height: "1.7rem" }}
                  src={F1}
                  alt="seobix"
                />
              </a>
              <div className="">
                <a
                  href="/pricing-plans"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  Pricing
                </a>
              </div>
              <div className="mt-2">
                <a
                  href="/blog"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  <p style={{ color: "#fff", marginBottom: 0 }}>Blog</p>
                </a>
              </div>
              <div className="mt-2">
                <a
                  href="/privacy-policy"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  Privacy Policy
                </a>
              </div>
              <div className="mt-2">
                <a
                  href="/terms-and-conditions"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  Terms & Conditions
                </a>
              </div>
              <div className="mt-2">
                <a
                  href="/faq"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  FAQ
                </a>
              </div>
              <div className="mt-2">
                <a
                  href="/contact-us"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  Contact us
                </a>
              </div>
            </div>
            <div className="col">
              <div className="mt-2">
                <h6 className="" style={{ color: "#fff" }}>
                  <b>Research Tools</b>
                </h6>
              </div>
              <div className="mt-2">
                <a
                  href="/competitive-research-with-seobix-understand-your-competitors-strategies"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  Competitive Research
                </a>
              </div>
              <div className="mt-2">
                <a
                  href="/transform-your-content-with-google-structured-data-for-better-search-results"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  Structure Data
                </a>
              </div>
              <div className="mt-2">
                <a
                  href="/best-keyword-research-tool-in-india-2025"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  Keyword Research
                </a>
              </div>
              <div className="mt-2">
                <a
                  href="/best-free-on-page-seo-tool-for-high-google-rankings"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  On-Page-Seo
                </a>
              </div>
            </div>
            <div className="col">
              <div className="mt-2">
                <h6 className="" style={{ color: "#fff" }}>
                  <b>Trending Tools</b>
                </h6>
              </div>

              <div className="mt-2">
                <a
                  href="/free-google-trends-tool"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  Google Trends
                </a>
              </div>
              <div className="mt-2">
                <a
                  href="/best-free-on-page-seo-tool-for-high-google-rankings"
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  Search Console
                </a>
              </div>
            </div>

            <div className="col ">
            
              <h6 className="mt-1 mx-md-2" style={{ color: "#fff" }}>
                Follow US
              </h6>
              <div className="d-flex align-items-start justify-content-evenly">
                <a target="_blank" rel="noopener noreferrer">
                  <img
                    className="insta m-1"
                    alt="seobix"
                    style={{ height: "3rem", cursor: "pointer" }}
                    src={F2}
                  />
                </a>
                <a target="_blank" rel="noopener noreferrer">
                  <img
                    className="facebook m-1"
                    alt="seobix"
                    style={{ height: "3rem" }}
                    src={F3}
                  />
                </a>

                <a target="_blank" rel="noopener noreferrer">
                  <img
                    className="adin m-1"
                    alt="seobix"
                    style={{ height: "3rem" }}
                    src={F4}
                  />
                </a>
              </div>
            
            </div>
            <div className="col-md-1"></div>
          </div>
        
              <p
            className="text-center mx-auto "
            style={{
              fontSize: "1rem",
              maxWidth: "90%",
              lineHeight: "1.5",
              color: "#fff",
            }}
          >
          Contact us -  9958854324
          </p>
          <p
            className="text-center mx-auto "
            style={{
              fontSize: "1rem",
              maxWidth: "90%",
              lineHeight: "1.5",
              color: "#fff",
            }}
          >
            Ithum Tower, Tower-B, 212A, Second Floor,Sector 62 Noida-201309
          </p>
          <hr className="px-5" style={{ color: "#fff" }} />
        </div>
      </div>
    </>
  );
};

export default Footer;
